export default class DelayedCall
{
    protected delayTimer = null;

    public execute(callback: Function, delay: number, context: any = null, ...params)
    {
        this.cancelLastCall();

        return new Promise((resolve, reject) => {            
            this.delayTimer = setTimeout(
                () => {
                    if (context !== null) {
                        callback = callback.bind(context);
                    }

                    let result = callback(...params);

                    if (result === false) {
                        reject();
                    } else {
                        resolve(result);
                    }
                },
                delay
            );
        });
    }

    public cancelLastCall()
    {
        clearTimeout(this.delayTimer);
    }
}
